import { Component, Vue } from 'vue-property-decorator'
import feedBacktem from '@/components/feedBack/index.vue'
import { editApplyInfo } from '@/api'
import merge from 'webpack-merge'

@Component({ name: 'feedback', components: { feedBacktem } })
export default class FeedBack extends Vue {
  private feedbacType: any = null // 1。新增反馈 2。修改反馈
  private queryobj: any = {}
  private applyType: any = '空'
  private applyDetail: any = ''
  private sellOrderId: any = ''
  private applySelectList: any = ['空', '有', '无', '待定', '不建议', '需学生自行与教授确认']

  created () {
    console.log(' this.$route.query: ', this.$route.query)
    const obj: any = {
      studentId: this.$route.query.studentId,
      sellOrderId: this.$route.query.sellOrderId,
      classId: this.$route.query.classId,
      isCurrentClass: this.$route.query.isCurrentClass,
      createStr: this.$route.query.createStr,
      studentName: this.$route.query.studentName
    }
    this.sellOrderId = this.$route.query.sellOrderId
    this.applyType = this.$route.query.applyType
    this.applyDetail = this.$route.query.applyDetail
    this.queryobj = obj
    this.feedbacType = this.$route.query.type
    if (this.feedbacType) {
      this.$route.meta.name = '编辑反馈'
    } else {
      this.$route.meta.name = '查看反馈'
    }
  }

  private async saveApplyInfo (item: any) {
    const { error }: any = await editApplyInfo({
      sellOrderId: this.sellOrderId,
      applyType: this.applyType,
      applyDetail: this.applyDetail
    })
    if (!error) {
      this.$message({ message: '修改Course Code成功', type: 'success' })
      const _query: any = { query: merge(this.$route.query, { applyType: this.applyType, applyDetail: this.applyDetail }) }
      this.$router.push(_query)
    }
  }
}
